import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import InvoiceDetails from "../views/Invoice/InvoiceDetails.vue";
import Invoices from "../views/Invoice/Invoices.vue";
import Categories from "../views/Categories.vue";
import Products from "../views/Product/Products.vue";
import ProductOffers from "../views/ProductOffer/ProductOffers.vue";
import Billing from "../views/Billing.vue";
import QRCode from "../views/QRCode.vue";
import AI from "../views/AI.vue";
import AIChat from "../views/AIChat.vue";
import Hangfire from "../views/Hangfire.vue";

import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import { authService } from "../services/authService.js";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
    meta: { requiresAuth: true }
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: "/invoices",
    name: "Invoices",
    component: Invoices,
    meta: { requiresAuth: true }
  },
  {
    path: "/products",
    name: "Products",
    component: Products,
    meta: { requiresAuth: true }
  },
  {
    path: "/categories",
    name: "Categories",
    component: Categories,
    meta: { requiresAuth: true }
  },
  {
    path: "/productoffers",
    name: "ProductOffers",
    component: ProductOffers,
    meta: { requiresAuth: true }
  },
  {
    path: "/inventory",
    name: "Inventory",
    component: () => import("@/views/Inventory/Inventory.vue"),
    meta: {
      forceReload: true, // Wymusza ponowne załadowanie komponentu przy każdej zmianie trasy
    }
  },
  {
    path: "/inventory-stock",
    name: "InventoryStock",
    component: () =>
      import(
        "@/views/Inventory/InventoryStock.vue"
      )
  },
  {
    path: "/inventory-profitability",
    name: "InventoryProfitability",
    component: () =>
      import(
        "@/views/Inventory/InventoryProfitability.vue"
      )
  },
  {
    path: "/inventory-activity",
    name: "InventoryActivity",
    component: () =>
      import(
        "@/views/Inventory/InventoryActivity.vue"
      )
  },
  {
    path: "/inventory/create",
    name: "InventoryCreate",
    component: () => import("@/views/Inventory/InventoryDetails.vue"),
  },
  {
    path: "/inventory/:id",
    name: "InventoryDetails",
    component: () => import("@/views/Inventory/InventoryDetails.vue"),
    meta: {
      forceReload: true, // Wymusza ponowne załadowanie komponentu przy każdej zmianie trasy
    }
  },
  {
    path: "/media",
    name: "MediaLibrary",

    component:
      () =>
        import(
          "@/views/Media/MediaLibrary.vue"
        )
  },
  {
    path: "/production/configuration",
    name: "ProductionConfiguration",
    component: () =>
      import(
        "@/views/Production/ProductionConfiguration.vue"
      )
  },
  {
    path: "/production/jobs",
    name: "production-jobs",
    component: () =>
      import("@/views/Production/ProductionJobs.vue")
  },
  {
    path: "/orders",
    name: "orders",
    component: () =>
      import("@/views/Orders/Orders.vue")
  },

  {
    path: "/orders/new",
    name: "order-new",
    component: () =>
      import("@/views/Orders/OrderEditor.vue")
  },

  {
    path: "/orders/:id/edit",
    name: "order-edit",
    component: () =>
      import("@/views/Orders/OrderEditor.vue")
  },

  {
    path: "/orders/:id",
    name: "order-details",
    component: () =>
      import("@/views/Orders/OrderDetails.vue")
  },
  {
    path: "/invoice/:id?",
    name: "Invoice",
    component: InvoiceDetails,
    meta: { requiresAuth: true }
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
    meta: { requiresAuth: true }
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: { requiresAuth: true }
  },
  {
    path: "/qrcode",
    name: "QRCode",
    component: QRCode,
    meta: { requiresAuth: true }
  },
  {
    path: "/ai",
    name: "AI",
    component: AI,
    meta: { requiresAuth: true }
  },
  {
    path: "/aiChat",
    name: "AIChat",
    component: AIChat,
    meta: { requiresAuth: true }
  },
  {
    path: "/allegro/orders/sync",
    name: "AllegroOrderSync",
    component: () =>
      import(
        "@/views/Allegro/AllegroOrderSync.vue"
      )
  },
  {
    path: "/allegro/test",
    name: "AllegroClientTest",
    component: () =>
      import(
        "@/views/Allegro/AllegroClientTest.vue"
      )
  },
  {
    path: "/hangfire",
    name: "Hangfire",
    component: Hangfire,
    meta: { requiresAuth: true }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  //console.log('to', to);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authService.isLogged()) {
      // Przekieruj na stronę logowania, jeśli nie ma tokenu
      next({
        name: 'Signin',
        query: {
          nextUrl: to.fullPath,
        }
      });
    } else {
      // Kontynuuj, jeśli token istnieje
      next();
    }
  } else {
    next(); // Zawsze pozwól na przejście, jeśli nie wymaga autoryzacji
  }
});

export default router;
